import React from 'react'
import RenderRefMarker from 'Components/Map/MapMarkers/RenderRefMarker.js'
import RenderCreationMarker from 'Components/Map/MapMarkers/RenderCreationMarker.js'

import { useSelector } from 'react-redux'

export const MapRefs = ({ ids }) => {
  const moduleType = 'refs'
  const wip = useSelector((state) => state.modules[moduleType].wip)
  const preferences = useSelector((state) => state.login.preferences[moduleType])

  return (
    <>
      {wip?.geoJson && <RenderCreationMarker wip={wip} />}
      {ids
        ?.filter((f) => !preferences[f]?.invisible)
        ?.map((eachModule) => {
          const moduleId = eachModule?.toString()
          if (!moduleId) {
            console.error('Module without id!')
            return null
          }
          return <RenderRefMarker key={moduleId} moduleId={moduleId} />
        })}
    </>
  )
}
